import React, { useState, useEffect } from 'react';
import {
    IoCalendarOutline,
    IoSettingsOutline,
    IoLogOutOutline,
} from 'react-icons/io5';
import { FaTrophy } from 'react-icons/fa'
import logo from '../Images/logo.png';
import { useAuth0 } from "@auth0/auth0-react";
import { RiArticleLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { MdOutlineFeedback, MdCreate } from "react-icons/md";
import {IoIosNotifications} from "react-icons/io"
import FeedbackModal from './FeedbackModal';

function NavItem({ label, icon, onClick, isActive }) {
    return (
        <button
            onClick={onClick}
            className={`w-full flex items-center justify-start gap-3 p-3 text-slate-300 hover:text-white hover:bg-slate-800/50 ${isActive ? "bg-slate-800/50 text-white" : ""}`}
        >
            {icon}
            <span className="text-sm">{label}</span>
        </button>
    );
}

function AffiliateModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({ name: '', email: '', website: '' });

  const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
      e.preventDefault();

      fetch('https://trendhopper-c3934b7293e6.herokuapp.com/api/affiliate-signup/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
      }).then(response => {
          if (response.ok) {
              alert('Application submitted successfully!');
              onClose();
          } else {
              alert('Error submitting application');
          }
      });
  };

  if (!isOpen) return null;

  return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-slate-900 p-6 rounded-lg w-96 relative z-50 text-white">
              <h2 className="text-xl font-bold mb-3">Earn Recurring Income as an Affiliate!</h2>

              <p className="text-sm mb-4">
                  Join the <strong>Trendhopper AI Affiliate Program</strong> and earn up to
                  <strong> $20 per sale every month—forever.</strong>
              </p>

              <ul className="list-disc list-inside text-sm mb-4">
                  <li>💰 Recurring commissions for life</li>
                  <li>📢 Promote a cutting-edge AI platform</li>
                  <li>🚀 Easy sign-up & instant tracking</li>
              </ul>

              <form onSubmit={handleSubmit} className="flex flex-col gap-3">
                  <input
                      type="text" name="name" placeholder="Your Name"
                      value={formData.name} onChange={handleChange}
                      className="p-2 rounded bg-gray-800 text-white"
                      required
                  />
                  <input
                      type="email" name="email" placeholder="Your Email"
                      value={formData.email} onChange={handleChange}
                      className="p-2 rounded bg-gray-800 text-white"
                      required
                  />
                  <input
                      type="text" name="website" placeholder="Your Website (optional)"
                      value={formData.website} onChange={handleChange}
                      className="p-2 rounded bg-gray-800 text-white"
                  />
                  <button type="submit" className="bg-green-500 p-2 rounded text-white font-semibold">
                      Apply Now
                  </button>
                  <button type="button" onClick={onClose} className="bg-gray-700 p-2 rounded text-white">
                      Cancel
                  </button>
              </form>
          </div>
      </div>
  );
}



export function AppSidebar({ onSelect, activePage }) {
    const { logout } = useAuth0();
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };
    const location = useLocation();
    const isArticleView = location.pathname.startsWith('/article/');
    const [isModalOpen, setIsModalOpen] = useState(false);


    return (
        <>
            {isMobile ? (
                // Mobile Sidebar
                <div
                    className={`flex h-screen flex-col border-r border-slate-800/50 bg-slate-900 p-2 w-48 fixed top-0 left-0 z-10 transition-transform duration-300 ease-in-out ${
                        isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
                    }`}
                >
                    {/* Back Button */}
                    <button
                        onClick={toggleSidebar}
                        className="absolute top-2 left-2 p-2 text-white focus:outline-none"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            className="h-6 w-6"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 19l-7-7 7-7"
                            />
                        </svg>
                    </button>
                    <div
                        className="flex items-center mb-4 cursor-pointer mt-6 justify-start"
                        onClick={() => navigate('/articles-table-view')}
                    >
                        <img src={logo} alt="TrendHopper Logo" className="h-10 w-10 mx-0" />
                        <h1 className=" text-lg font-bold text-white">
                            TrendHopper
                        </h1>
                    </div>
                    <nav className="flex-1 space-y-1">
                        <NavItem
                            label="Content Calendar"
                            icon={<IoCalendarOutline className="h-6 w-6 sm:h-5 sm:w-5" />}
                            isActive={activePage === 'contentCalendar'}
                            onClick={() => { onSelect('contentCalendar'); toggleSidebar(); }}
                        />
                        <NavItem
                            label="Articles"
                            icon={<RiArticleLine className="h-6 w-6 sm:h-5 sm:w-5" />}
                            isActive={activePage === 'articlesTableView'}
                            onClick={() => { onSelect('articlesTableView'); toggleSidebar(); }}
                        />
                        <NavItem
                            label="Settings"
                            icon={<IoSettingsOutline className="h-6 w-6 sm:h-5 sm:w-5" />}
                            isActive={activePage === 'settings'}
                            onClick={() => { onSelect('settings'); toggleSidebar(); }}
                        />
                        <NavItem
                          label="Create Article"
                          icon={<IoIosNotifications className="h-6 w-6 sm:h-5 sm:w-5" />}  // Use appropriate icon
                          isActive={activePage === 'createArticle'}
                          onClick={() => { onSelect('createArticle'); toggleSidebar(); }}
                      />
                        <NavItem
                            label="Feedback"
                            icon={<MdOutlineFeedback className="h-6 w-6 sm:h-5 sm:w-5" />}
                            onClick={() => { onSelect('settings'); toggleSidebar(); }}
                        />
                         <NavItem
                            label="Logout"
                            icon={<IoLogOutOutline className="h-6 w-6" />}
                            onClick={() => {
                                localStorage.removeItem("userId")
                                localStorage.removeItem("user_id")
                                logout({ logoutParams: { returnTo: window.location.origin } });
                                toggleSidebar();
                            }}
                        />
                    </nav>
                </div>
            ) : (
                // Desktop Sidebar
                <div className="flex h-screen flex-col border-r border-slate-800/50 bg-slate-900/50 p-2 sm:w-48 w-12">
                  <div
                      className="flex items-center mb-4 cursor-pointer"
                      onClick={() => navigate('/articles-table-view')}
                  >
                      <img src={logo} alt="TrendHopper Logo" className="h-10 w-10 mx-auto sm:mx-0" />
                      <h1 className="hidden sm:block text-lg font-bold text-white">
                          Trendhopper
                      </h1>
                  </div>

                    <nav className="flex-1 space-y-1">
                        <NavItem
                            label="Content Calendar"
                            icon={<IoCalendarOutline className="h-6 w-6 sm:h-5 sm:w-5" />}
                            isActive={activePage === 'contentCalendar'}
                            onClick={() => onSelect('contentCalendar')}
                        />
                        <NavItem
                            label="Articles"
                            icon={<RiArticleLine className="h-6 w-6 sm:h-5 sm:w-5" />}
                            isActive={activePage === 'articlesTableView'}
                            onClick={() => onSelect('articlesTableView')}
                        />
                        <NavItem
                            label="Settings"
                            icon={<IoSettingsOutline className="h-6 w-6 sm:h-5 sm:w-5" />}
                            isActive={activePage === 'settings'}
                            onClick={() => onSelect('settings')}
                        />
                        <NavItem
                          label="Write"
                          icon={<MdCreate className="h-6 w-6 sm:h-5 sm:w-5" />}  // Use appropriate icon
                          isActive={activePage === 'createArticle'}
                          onClick={() => { onSelect('createArticle'); toggleSidebar(); }}
                      />
                        <FeedbackModal isOpen={isOpen} setIsOpen={setIsOpen} />

                    </nav>

                    <div className="mt-auto pb-4">
                    <button
                        className="w-full flex items-center justify-start gap-3 p-3 text-slate-300 hover:text-white hover:bg-slate-800/50 rounded"
                        onClick={() => setIsModalOpen(true)}
                    >
                        <FaTrophy className="h-5 w-5 text-yellow-400" />
                        <span className="hidden sm:inline text-sm">Affiliate Program</span>
                    </button>

                    {/* Logout Button */}
                    <button
                        onClick={() => {
                            localStorage.removeItem("userId")
                            localStorage.removeItem("user_id")
                            logout({ logoutParams: { returnTo: window.location.origin } });
                        }}
                        className="w-full flex items-center justify-start gap-3 p-3 text-slate-300 hover:text-white hover:bg-slate-800/50 rounded"
                    >
                        <IoLogOutOutline className="h-6 w-6" />
                        <span className="hidden sm:inline text-sm">Logout</span>
                    </button>
                </div>
                    <AffiliateModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

                </div>
            )}
            {/* Hamburger Menu Button (Visible on Small Screens) */}
            {isMobile && !isSidebarOpen && !isArticleView && (
    <button
        onClick={toggleSidebar}
        className="absolute top-2 left-2 p-2 text-white focus:outline-none z-20"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="h-6 w-6"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
            />
        </svg>
    </button>
)}

        </>
    );
}
